<h4>Seleccionar los grupos de especies de la actividad</h4>
<rpe-check-list-form [formInput]="formInputCheckList" (formStatusChanges)="formStatusChanges($event)"
  (formValueChanges)="formValueChanges($event)">
</rpe-check-list-form>
<div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
  <button (click)="onCancel()" mat-raised-button>
    {{ 'rpe.vista-usuario.volver' | translate }}
  </button>
  <button type="submit" mat-raised-button (click)="onGuardar()" color="primary">
    {{ 'rpe.vista-usuario.guardar-y-continuar' | translate }}
  </button>
</div>